export const BRAND_NAME = 'TabHub';
export const BRAND_LOGO_CONSTRAST = 'mock-logo.png';
export const LOGIN_IMG = 'login-png.png';
